import React from 'react';
import { useTranslation } from 'react-i18next';

function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="footer">
      <div className="footer-content">
        <p>
          © {new Date().getFullYear()}
          <a
            href="https://strategos.cat"
            target="_blank"
            rel="noopener noreferrer"
            className="footer-link"
          >
            Strategos.cat
          </a>
          . {t('footer.allRightsReserved')}
        </p>
      </div>
    </footer>
  );
}

export default Footer;